import { Card } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link, useParams } from "react-router-dom";
import AdminLayout from "../../Layout";
import { auth } from "../../../../utils/firebase";
import { useQuery, gql } from "@apollo/client";
import {
  useGetCampusQuery,
  useGetStaffByEmailIdQuery,
} from "../../../../graphql/generated.tsx";

const GET_MODULES_BY_CAMPUS = gql`
  query GetModulesByCampus($campusName: String!) {
    getModulesByCampus(campusName: $campusName) {
      moduleID
      enabled_dates
    }
  }
`;


const ReportType = () => {
  const { campusName: campusParam } = useParams();
  const [user, setUser] = useState();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);
  const userRole = user
    ? JSON.parse(user?.reloadUserInfo?.customAttributes).role
    : null;

  const { data: staffData, loading: staffLoading } = useGetStaffByEmailIdQuery({
    variables: { email: user?.email },
  });

  const { data: campusDetails, loading: campusLoading } = useGetCampusQuery({
    variables: { id: staffData?.getStaffByEmailId?.campusId },
    skip: staffLoading,
  });

  let staffCampusName = "";
  if (userRole === "staff") {
    staffCampusName = campusDetails?.campus.name;
  }

  const activeCampus = campusParam || staffCampusName || campusDetails?.campus?.name;

  // Query for modules by campus
  const { data: modulesData } = useQuery(GET_MODULES_BY_CAMPUS, {
    variables: { campusName: activeCampus },
    skip: !activeCampus,
  });

  const hasModules = modulesData?.getModulesByCampus?.length > 0;

  return (
    <AdminLayout>
      
      <div className="p-10">
        <div className="flex items-center justify-between mb-8 max-md:gap-2">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <IoMdArrowRoundBack className="w-6 h-6" />
            </button>
            <div className="ml-2 text-2xl font-bold text-gray-800 max-md:text-lg">
              {activeCampus ? `${activeCampus} Reports` : "Reports"}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          <Link
            to={
              activeCampus
                ? `/admin/reports/assignments/${activeCampus}`
                : userRole === "staff"
                ? `/admin/reports/assignments/${staffCampusName}`
                : `/admin/reports/assignment`
            }
          >
            <Card className="h-[200px] flex items-center justify-center transform transition-transform duration-300 hover:scale-105 hover:shadow-lg bg-white">
              <h5 className="text-2xl font-bold tracking-tight">Assignments</h5>
            </Card>
          </Link>
          <Link
            to={
              activeCampus
                ? `/admin/reports/course/${activeCampus}`
                : userRole === "staff"
                ? `/admin/reports/course/${staffCampusName}`
                : `/admin/reports/course`
            }
          >
            <Card className="h-[200px] flex items-center justify-center transform transition-transform duration-300 hover:scale-105 hover:shadow-lg bg-white">
              <h5 className="text-2xl font-bold tracking-tight">Course</h5>
            </Card>
          </Link>
          <Link
            to={
              activeCampus
                ? `/admin/reports/module/${activeCampus}`
                : userRole === "staff"
                ? `/admin/reports/module/${staffCampusName}`
                : `/admin/reports/module`
            }
          >
            <Card className="h-[200px] flex items-center justify-center transform transition-transform duration-300 hover:scale-105 hover:shadow-lg bg-white">
              <h5 className="text-2xl font-bold tracking-tight">Module</h5>
            </Card>
          </Link>
          {(activeCampus || userRole !== "staff") && (
            <Link
              to={
                activeCampus
                  ? `/admin/reports/leetcode/${activeCampus}`
                  : `/admin/reports/leetcode`
              }
            >
              <Card className="h-[200px] flex items-center justify-center transform transition-transform duration-300 hover:scale-105 hover:shadow-lg bg-white">
                <h5 className="text-2xl font-bold tracking-tight">Leetcode</h5>
              </Card>
            </Link>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default ReportType;
